import React from "react";
import PropTypes from "prop-types";
import styles from "./FilterTabs.module.css";

const FilterTabs = ({
  selectedFilter,
  onFilterChange,
  setInitialLoad,
  setIsTabClicked,
}) => {
  const filterOptions = [
    { value: "12", label: "12 MONTHS" },
    { value: "24", label: "24 MONTHS" },
    { value: "36", label: "36 MONTHS" },
    { value: "48", label: "48 MONTHS" },
    { value: "60", label: "60 MONTHS" },
    { value: "monthly", label: "MONTHLY" },
  ];

  return (
    <div className={styles.filterTabs}>
      <div className={styles.filterTabsInner}>
        {filterOptions.map((option) => (
          <button
            key={option.value}
            className={styles.filterTab}
            onClick={() => {
              onFilterChange(option.value);
              setInitialLoad(true);
              setIsTabClicked(true);
            }}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

FilterTabs.propTypes = {
  selectedFilter: PropTypes.string.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  setInitialLoad: PropTypes.func.isRequired,
  setIsTabClicked: PropTypes.func.isRequired,
};

export default FilterTabs;
